import React from 'react';
import { Columns } from '@components/Columns';
import {
  StyledSection,
  ColumnFlex,
  FeatureText,
  StyledColumn,
  FeaturesTextPairing,
  StyledTopWave,
  StyledBottomGoldThread,
} from './SmartRSVPInviteFeatureSection.styles';
import { CloudImage } from '@components/CloudImage';
import { useTranslation } from 'react-i18next';

interface SmartRSVPInviteFeatureSectionProps {}

export const SmartRSVPInviteFeatureSection: React.FC<SmartRSVPInviteFeatureSectionProps> = () => {
  const { t } = useTranslation('onlineRsvp');
  const smartRSVPInviteData = t('smartRSVPInviteFeatureSection');
  return (
    <StyledSection backgroundColor="humana1Light" as="section" id="Registry_Features" paddingTop={[8]} paddingBottom={[12]}>
      <StyledTopWave src="online-rsvp/top-wave.svg" optimization="aggressive" />
      <FeaturesTextPairing
        alignment="center"
        title={smartRSVPInviteData.mainTextTitle}
        titleColor="neutra6"
        titleVariant="calloutHed40"
        titleTagName="h2"
        body={smartRSVPInviteData.mainTextBody}
        bodyVariant="dek20"
        bodyColor="neutra6"
      />
      <StyledColumn marginTop={[5, 10]} centered verticalAlign="flex-start">
        {smartRSVPInviteData.featureList.map((item, index) => (
          <Columns.Column key={index} width={3}>
            <ColumnFlex alignItems="center" flexDirection="column">
              <CloudImage src={item.image} width={60} height={62} optimization="aggressive" />
              <FeatureText
                alignment="center"
                title={item.title}
                titleVariant="featureHed17"
                titleColor="neutra6"
                body={item.body}
                bodyVariant="featureCopy17"
                bodyColor="neutra5"
                titleTagName="h2"
              />
            </ColumnFlex>
          </Columns.Column>
        ))}
      </StyledColumn>
      <StyledBottomGoldThread src="online-rsvp/gold-thread.svg" />
    </StyledSection>
  );
};
